/**
 * TradingFooter
 * 交易页面底部状态栏组件
 * 包含连接状态、延迟、时间、API文档链接
 *
 * @author page
 * @date 2026-04-23
 */
import React, {useEffect, useState} from 'react';
import styles from './TradingFooter.module.css';

interface TradingFooterProps {
    latency?: number;
    serverStatus?: 'connected' | 'disconnected';
}

const TradingFooter: React.FC<TradingFooterProps> = ({
                                                         latency = 12,
                                                         serverStatus = 'connected'
                                                     }) => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const formatTime = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} (UTC+8)`;
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.left}>
                <div className={styles.statusItem}>
                    <span
                        className={`${styles.statusDot} ${serverStatus === 'connected' ? styles.connected : styles.disconnected}`}></span>
                    <span>服务器连接{serverStatus === 'connected' ? '正常' : '异常'}</span>
                </div>
                <span className={styles.divider}>|</span>
                <span>延迟: <span className={styles.latency}>{latency}ms</span></span>
            </div>
            <div className={styles.right}>
                <span className={styles.time}>{formatTime(currentTime)}</span>
                <span className={styles.divider}>|</span>
                <a href="#" className={styles.apiLink}>API 文档</a>
            </div>
        </footer>
    );
};

export default TradingFooter;
